import store from "../store";

export default async function is_admins({ next, router }) {
    await store.dispatch('profile/role');
    let role = await store.getters['profile/role'];
    if ( (role !== 'mini-admin') && (role !== 'admin') ) {
        return router.push({ name: "User Profile" });
    }

    return next();
}
